import type { IInteractiveExamAttemptResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { interactiveExamFinishAttempt } from "@api/courses/exams/interactive/attempts/finish/api";
import { examAttemptQuestions } from "@api/courses/exams/interactive/attempts/questions/api";
import { interactiveExamSubmissions } from "@api/courses/exams/interactive/attempts//submissions/api";
import { latest } from "@api/courses/exams/interactive/attempts/latest/api";

const postApis = createPostApi<
  IApiResponse<IInteractiveExamAttemptResponse>,
  IPathBaseParam,
  undefined
>("courses.exams.interactive.interactiveExamAttempt");
const getApis = createGetApi<
  IApiResponse<IInteractiveExamAttemptResponse>,
  IPathByIdParam,
  object
>("courses.exams.interactive.interactiveExamAttempt");

export const interactiveExamAttempt = {
  ...getApis,
  ...postApis,
  interactiveExamFinishAttempt,
  examAttemptQuestions,
  interactiveExamSubmissions,
  latest,
};
